import React from 'react';

export default props => (
  <svg {...props} version="1.1" viewBox="0 0 50 50">
    <g id="Page-1" fill="none" stroke="none" strokeWidth="1">
      <g id="App-Store-50x50-Icon-Bordered">
        <g id="Rectangle-1-+-Imported-Layers-Copy">
          <rect
            height="48"
            id="Rectangle-1"
            width="48"
            rx="10"
            stroke="#9B9B9B"
            strokeWidth="2"
            x="1"
            y="1"
          />
          <path
            id="Imported-Layers"
            d="M30.6886857,17.2488095 C33.9314286,17.2488095 36.0050286,20.3863333 36.0050286,20.3863333 C36.0050286,20.3863333 32.8418286,22.1028571 32.8418286,25.8307381 C32.8418286,30.2553095 36.8155429,31.5423571 36.8155429,31.5423571 C36.8155429,31.5423571 33.6790857,38.9843095 30.1572571,38.9843095 C28.1769143,38.9843095 28.0445714,37.8450238 25.4128,37.8450238 C23.1273143,37.8450238 22.3565714,38.9843095 20.6155429,38.9843095 C17.2925714,38.9843095 13,31.7301667 13,25.8307381 C13,19.7027619 17.3460571,17.2488095 20.0704,17.2488095 C22.4628571,17.2488095 23.4592,18.6566905 25.3860571,18.6566905 C27.0077714,18.6566905 28.2838857,17.2488095 30.6886857,17.2488095 L30.6886857,17.2488095 Z M30.1312,11 C30.6091429,14.0035714 27.8848,17.7183333 24.6290286,17.5975 C24.1504,13.7757143 27.6592,11.201619 30.1312,11 L30.1312,11 Z"
            fill="#9B9B9B"
          />
        </g>
      </g>
    </g>
  </svg>
);
